export default "__VITE_PUBLIC_ASSET__5d2aeb67__"